import { FilterRecapture } from '@app/core/models/common/filter-recapture';
import { Recapture, Filter, ICESTotal, ICESFilter, ICESRecaptures, ICESReleases, ICESRecaptureGroup } from '../../models';
import { FormatterHelper } from '../common/formatter.helper';

export class RecapturesHelper {

    protected formatter: FormatterHelper;
    public recaptures: Recapture[];

    constructor() {
        this.recaptures = [];
        this.formatter = new FormatterHelper();
    }

    public createRecapture(data: any): Recapture {
        let recapture: Recapture = {
            ReleasedICES: data.RelICES,
            ReleasedYear: data.RelTime,
            RecapturedTime: data.RecTime,
            RecapturedYear: new Date(data.RecTime).getFullYear(),
            RecapturedTimestamp: new Date(data.RecTime),
            ReleasedLongitude: this.formatter.convertToISODecimal(data.RelPosLO),
            ReleasedLatitude: this.formatter.convertToISODecimal(data.RelPosLA),
            RecapturedFactoryId: data.FactoryID,
            RecapturedFactory: data.RecFactory,
            RecapturedArea: data.RecArea ? data.RecArea : '?',
            RecapturedExpedition: data.Expedition
        }
        return recapture;
    }

    public findRecaptures(filter: FilterRecapture): Recapture[] {
        return this.recaptures.filter(function(recapture) {
            return (
                (filter.Year == 0 || recapture.RecapturedYear === filter.Year) &&
                (filter.Factory.length == 0 || filter.Factory.includes('') || filter.Factory.includes(recapture.RecapturedFactoryId)) &&
                ((filter.ReleaseYear == 0 || recapture.ReleasedYear === filter.ReleaseYear)) &&
                (filter.Expedition.length == 0 || filter.Expedition.includes('') || filter.Expedition.includes(recapture.RecapturedExpedition))
            )});
    }

    public findRecapturesByReleasedICES(filter: ICESFilter): Recapture[] {
        return this.recaptures.filter(recapture =>
            ((filter.Year == 0 || recapture.ReleasedYear === filter.Year) && recapture.ReleasedICES === filter.ICES));
    }

    public findRecapturesByRecapturedICES(filter: ICESFilter): Recapture[] {
        return this.recaptures.filter(recapture =>
        ((filter.Year == 0 || recapture.RecapturedYear === filter.Year)
            && (filter.Factory.length == 0 || filter.Factory.includes('') || filter.Factory.includes(recapture.RecapturedFactoryId))
            && recapture.RecapturedArea === filter.ICES));
    }

    public findReleasesByICES(filter: ICESFilter): Recapture[] {
        return this.recaptures.filter(recapture =>
        ((filter.Year == 0 || recapture.RecapturedYear === filter.Year)
            && (filter.Factory.length == 0 || filter.Factory.includes('') || filter.Factory.includes(recapture.RecapturedFactoryId))
            && recapture.RecapturedArea === filter.ICES));
    }

    public groupByICES(recaptures: Recapture[]): ICESRecaptureGroup[] {
        let groups = [];
        let result = recaptures.reduce((r, a) => this.group(r, a), Object.create(null));
        // Make a list of groups
        if (result) {
            for (let key in result) {
                if (key != '?') {
                    groups.push(result[key]);
                }
            }
        }
        return groups;
    }

    public getMinRecaptureGroup(groups: ICESRecaptureGroup[]): ICESRecaptureGroup {
        // return groups.reduce((a, b) => this.min(a, b));
        return this.formatter.getMinGroup(groups);
    }

    public getMaxRecaptureGroup(groups: ICESRecaptureGroup[]): ICESRecaptureGroup {
        // return groups.reduce((a, b) => this.max(a, b));
        return this.formatter.getMaxGroup(groups);
    }

    public getAccumulatedRecapturesByICES(recaptures: Recapture[]): ICESRecaptures {
        let icesRecaptures = new ICESRecaptures();
        let groups = [];
        let result = recaptures.reduce((r, a) => this.accumulateRecaptureGroup(r, a), Object.create(null));
        // Make a list of groups
        if (result) {
            for (let key in result) {
                if (key.indexOf('null') < 0) {
                    icesRecaptures.Total += result[key].Total;
                    icesRecaptures.Recaptures.push(result[key]);
                }
            }
        }
        return icesRecaptures;
    }

    public getAccumulatedReleasesByICES(recaptures: Recapture[]): ICESReleases {
        let icesRecaptures = new ICESReleases();
        let groups = [];
        let result = recaptures.reduce((r, a) => this.accumulateReleaseGroup(r, a), Object.create(null));
        // Make a list of groups
        if (result) {
            for (let key in result) {
                if (key.indexOf('null') < 0) {
                    icesRecaptures.Total += result[key].Total;
                    icesRecaptures.Releases.push(result[key]);
                }
            }
        }
        return icesRecaptures;
    }

    /* Helper functions */

    private group(r: any, a: any) {
        r[a.RecapturedArea] = r[a.RecapturedArea] || new ICESRecaptureGroup(a.RecapturedArea);
        r[a.RecapturedArea].Total += 1;
        r[a.RecapturedArea].Recaptures.push(a);
        return r;
    }

    private accumulateReleaseGroup(r: any, a: any) {
        let key = `${a.ReleasedICES}-${a.ReleasedYear}`;
        r[key] = r[key] || new ICESTotal(a.ReleasedICES);
        r[key].Total += 1;
        r[key].Year = a.ReleasedYear;
        return r;
    }

    private accumulateRecaptureGroup(r: any, a: any) {
        let key = `${a.RecapturedArea}-${a.RecapturedYear}`;
        r[key] = r[key] || new ICESTotal(a.RecapturedArea);
        r[key].Total += 1;
        r[key].Year = a.RecapturedYear;
        return r;
    }
}